/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Import_ExternalInputs */

const en_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing project file from external data...`)
};

const fr_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du fichier projet depuis des donnees externes...`)
};

const de_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiere Projektdatei aus externen Daten...`)
};

const it_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del file di progetto da dati esterni...`)
};

const ru_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт файла проекта из внешних источников данных...`)
};

const es_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando archivo de proyecto desde datos externos...`)
};

const zh_cn2_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从外部数据源导入项目文件...`)
};

const ja_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部データからプロジェクト ファイルをインポートしています...`)
};

const hi_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाह्य डेटा से प्रोजेक्ट फ़ाइल आयात की जा रही है...`)
};

const pt_pt2_load_project_file_status_import_external = /** @type {(inputs: Load_Project_File_Status_Import_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando arquivo de projeto de dados externos...`)
};

/**
* | output |
* | --- |
* | "Importing project file from external data..." |
*
* @param {Load_Project_File_Status_Import_ExternalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_import_external = /** @type {((inputs?: Load_Project_File_Status_Import_ExternalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Import_ExternalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_import_external(inputs)
	if (locale === "de") return de_load_project_file_status_import_external(inputs)
	if (locale === "it") return it_load_project_file_status_import_external(inputs)
	if (locale === "ru") return ru_load_project_file_status_import_external(inputs)
	if (locale === "es") return es_load_project_file_status_import_external(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_import_external(inputs)
	if (locale === "ja") return ja_load_project_file_status_import_external(inputs)
	if (locale === "hi") return hi_load_project_file_status_import_external(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_import_external(inputs)
	return en_load_project_file_status_import_external(inputs)
});